import SmartFeedEngine from "@/smart-feed/smart-feed-engine";
import { defineSmartFeedPiniaStore } from "@bloglovin/vue-framework";

export const useMyNetworkFeedStore = defineSmartFeedPiniaStore(
  "my-network-feed-store",
  {
    state: () => ({
      smartFeedEngine: new SmartFeedEngine(),
      feedUrl: "/network/my-networks",
      defaultFilterValues: {
        status: {
          key: "status",
          payload: "all",
        },
      },
      tableFields: [
        { key: "name", label: "Name" },
        { key: "status", label: "Status" },
      ],
    }),
  },
);
